<template>
	<!-- 页面内容的上半部分 -->
	<div class="upList">
		<div
			v-for="(items, indexs) in tableData"
			:key="indexs"
			class="list-item"
			:style="{ width: itemWidthFunction(items.text) }"
		>
			<div
				v-for="(item, index) in items.children"
				:key="index"
				class="item"
			>
				<a
					:href="getAlink(item.url, item.uid, item)"
					@click="gotoLink(item)"
					:class="getcDeepBlueClass(item.uid)"
					:style="{ width: upListWidthFunction(item.text) }"
					>{{ item.text }}
					<!-- <img
							v-if="item.shownew == true"
							src="../../../assets/special/listnews.png"
							alt=""
						/>
						<span
							v-else
							style="
								display: inline-block;
								width: 12px;
								height: 1px;
							"
						></span> -->
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import { getNav } from '../../../api/home';
export default {
	name: 'upList',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {
			tableData: [],
			//外层的宽度
			itemWidth: [
				{ name: '创新', width: '242px' },
				{ name: '协调', width: '582px' },
				{ name: '绿色', width: '142px' },
				{ name: '开放', width: '72px' },
				{ name: '共享', width: '200px' },
			],
			//宽度+paddingleft
			upListWidth: [
				//创新
				{ name: '中国式现代化', width: '94px' },
				{ name: '高质量发展', width: '80px' },
				{ name: '创新驱动', width: '66px' },
				{ name: '新质生产力', width: '94px' },
				{ name: '体制改革', width: '80px' },
				{ name: '数字经济', width: '66px' },
				{ name: '智慧城市', width: '94px' },
				{ name: '法治中国', width: '80px%' },
				//协调
				{ name: '区域协同发展', width: '110px' },
				{ name: '西部大开发', width: '138px' },
				{ name: '长三角一体化', width: '138px' },
				{ name: '东北全面振兴', width: '94px' },
				{ name: '中部地区崛起', width: '110px' },
				{ name: '东部地区率先发展', width: '120px' },

				{ name: '京津冀协同发展', width: '110px' },
				{ name: '长江经济带', width: '110px' },
				{ name: '黄河流域高质量发展', width: '138px' },
				{ name: '粤港澳大湾区', width: '94px' },
				{ name: '成渝双城经济圈', width: '110px' },
				{ name: '国家级新区', width: '100%' },
				{ name: '新型城镇化', width: '94px' },
				{ name: '乡村振兴', width: '110px' },
				//绿色
				{ name: '生态文明', width: '66px' },
				{ name: '资源环境', width: '66px' },
				{ name: '绿色发展', width: '66px' },
				{ name: '低碳经济', width: '66px' },
				{ name: '新能源产业', width: '100%' },
				//开放
				{ name: '对外开放', width: '100%' },
				{ name: '跨国投资', width: '100%' },
				{ name: '国际贸易', width: '100%' },
				//共享
				{ name: '共同富裕', width: '66px' },
				{ name: '人口与发展', width: '100%' },
				{ name: '社会保障', width: '66px' },
				{ name: '国情民生', width: '66px' },
				{ name: '优秀传统文化', width: '94px' },
				{ name: '中华民族共同体', width: '100%' },
			],
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.getNavs();
	},
	methods: {
		gotoLink(item) {
			this.$eventBus.$emit('upLists', item.uid);
		},
		//导航上的跳转链接-打开新页跳转的
		getAlink(url, uid, item) {
			var returnUrl = 'javascript:void(0);';
			if (
				this.$route.name != 'specialTopicNoLeft' &&
				item.children.length <= 0 &&
				item.tagIds == null
			) {
				returnUrl = '/specialTopicNoLeft?uid=' + uid;
			}

			if (
				this.$route.name != 'specialTopic' &&
				(item.children.length > 0 || item.tagIds != null)
			) {
				returnUrl = '/specialTopic?uid=' + uid;
			}

			return returnUrl;
		},
		getNavs() {
			getNav({ uid: 'A7', depth: '0' }).then((res) => {
				let templist = res.data.data;
				for (let index = 0; index < templist.length; index++) {
					const element = templist[index];
					if (element.uid == 'A705') {
						for (let j = 0; j < element.children.length; j++) {
							const data = element.children[j];
							if (data.isnav == true) {
								this.tableData.push(data);
							}
						}
					}
				}
			});
		},
		//设置avtive的颜色
		getcDeepBlueClass(_uid) {
			if (this.$route.query && this.$route.query.uid) {
				if (_uid == this.$route.query.uid) {
					return 'cDeepBlue fontRed';
				}
				return 'cDeepBlue';
			} else {
				return 'cDeepBlue';
			}
		},
		//设置每块的宽度
		itemWidthFunction(text) {
			let itemWidth = this.itemWidth;

			if (itemWidth.findIndex((name) => name.name == text) >= 0) {
				for (let index = 0; index < itemWidth.length; index++) {
					const element = itemWidth[index];
					if (element.name == text) {
						return element.width;
					}
				}
			} else {
				return '100%';
			}
		},
		//设置每个文字框的宽度
		upListWidthFunction(text) {
			let upListWidth = this.upListWidth;

			if (upListWidth.findIndex((name) => name.name == text) >= 0) {
				for (let index = 0; index < upListWidth.length; index++) {
					const element = upListWidth[index];
					if (element.name == text) {
						return element.width;
					}
				}
			} else {
				return '100%';
			}
		},
	},
};
</script>
<style lang="less" scoped>
.upList {
	background: transparent;
	// border: 1px solid #aecff5;
	padding: 17px 0;
	height: 112px;
}
.upList {
	// background: rgb(240, 248, 255);
	display: flex;
	width: 1300px;
	// border: 1px solid #aecff5;
	.list-item {
		// display: grid;
		// grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
		display: block;
		// flex-flow: row wrap;
		// writing-mode: horizontal-tb !important;
		// writing-mode: vertical-lr !important;
		border-right: 1px solid #dddee0;
		padding-left: 8px;
		// margin-right: 8.5px;
		// padding-right: 3.5px;
		// justify-content: center;
		.item {
			align-items: center;
			// margin-bottom: 6px;
			// writing-mode: vertical-lr !important;
			// writing-mode: horizontal-tb !important;
			display: inline-block;
			height: 26px;
			// border-right: 1.5px solid #174683;
			// padding: 0 10px 0 26px;
			// padding-right: 12px; /* 调整右边框线的间距 */
			.cDeepBlue {
				text-align: left;
				display: block;
				width: 100%;
				cursor: pointer;
				font-size: 14px;
				color: #333333;
				font-family: 'Microsoft YaHei', '微软雅黑', 'Microsoft JhengHei',
					'华文细黑', STHeiti, MingLiu;
				line-height: 26px;
				/* 添加右边框线 */
			}
			.fontRed {
				color: #c30000;
				font-weight: 600;
			}
			/* 最后一列元素去除右边框线 */
		}
	}
	.list-item:last-child {
		border-right: none;
	}
	.list-item:first-child {
		padding-left: 0;
	}
}
</style>
